import React from 'react'
import PropTypes from 'prop-types'
import k8Icon from './assets/ss_k8admin_screenwidth.svg'
import hsIcon from './assets/ss_hsadmin_screenwidth.png'
import {
  DesktopViewWrapper,
  DesktopViewMessage,
  DesktopViewImg,
} from './component.styles'

const DEFAULT_MESSAGE = 'Please view on a desktop or\na wider screen.'
const DEFAULT_BREAKPOINT = 760

const DesktopView = ({
  children,
  className,
  message = DEFAULT_MESSAGE,
  selectedProgram,
  breakpoint = DEFAULT_BREAKPOINT,
  suppressMessage = false,
}) => {
  // Determine icon based on selectedProgram, default to K8
  const programKey = selectedProgram?.key
  const isHS = programKey === 'HS'
  const iconSrc = isHS ? hsIcon : k8Icon

  return (
    <>
      <DesktopViewWrapper $breakpoint={breakpoint} className={className}>
        {children}
      </DesktopViewWrapper>
      {!suppressMessage && (
        <DesktopViewMessage $breakpoint={breakpoint} className={className}>
          <DesktopViewImg alt="" src={iconSrc} />
          <p>
            {message.split('\n').map((line, i, arr) => (
              <React.Fragment key={i}>
                {line}
                {i < arr.length - 1 && <br />}
              </React.Fragment>
            ))}
          </p>
        </DesktopViewMessage>
      )}
    </>
  )
}

DesktopView.propTypes = {
  breakpoint: PropTypes.number,
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  message: PropTypes.string,
  selectedProgram: PropTypes.shape({
    key: PropTypes.string,
  }),
  suppressMessage: PropTypes.bool,
}

export default DesktopView
